/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useMemo } from 'react';
import Skeleton from 'src/styles/skeleton';
import { Currency } from 'src/components/Currency';
import { ProgressBar } from 'src/components/ProgressBar';
import { ProposalSplitType } from 'src/enums';
import { getMonth, getYear, ensureLocaleDate } from 'src/utils/dates';
import { DataServerDTO, GroupsDTO } from '../../utils/interfaces';
import { getAmoutColor } from '../../utils/formatText';

interface SplittedAmountProps {
  dataContract?: DataServerDTO;
  proposalSplitType?: ProposalSplitType;
}

export const SplittedAmount: React.FC<SplittedAmountProps> = ({
  dataContract,
  proposalSplitType,
}) => {
  const [date, setDate] = useState('');
  const [groups, setGroups] = useState<GroupsDTO[]>([]);

  function sortGroups(groupsList: GroupsDTO[]) {
    if (proposalSplitType !== ProposalSplitType.monthly) {
      // spot and free should only have one group
      return groupsList;
    }

    const sortedGroups = [...groupsList].sort((a, b) => {
      return (
        new Date(ensureLocaleDate(b.start_date)).getTime() -
        new Date(ensureLocaleDate(a.start_date)).getTime()
      );
    });

    const currentDate = new Date();

    return sortedGroups.filter(
      group =>
        group.status !== 'AC' ||
        (new Date(ensureLocaleDate(group.start_date)).getMonth() ===
          currentDate.getMonth() &&
          new Date(ensureLocaleDate(group.start_date)).getFullYear() ===
            currentDate.getFullYear()),
    );
  }

  const memoizedProgressBar = useMemo(() => {
    if (
      dataContract?.total_value != null &&
      groups[0]?.splitted_amount != null
    ) {
      return (
        <ProgressBar
          value={parseFloat(groups[0]?.splitted_amount)}
          max={parseFloat(dataContract.total_value)}
        />
      );
    }
    return <></>;
  }, [dataContract, groups]);

  useEffect(() => {
    if (dataContract?.included?.groups.length) {
      const sortedGroups = sortGroups(dataContract.included.groups);
      setGroups(sortedGroups);
      setDate(
        sortedGroups[0]?.start_date
          ? ensureLocaleDate(sortedGroups[0]?.start_date)
          : '',
      );
    }
  }, [dataContract]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '715px',
      }}
    >
      <div>
        {proposalSplitType === ProposalSplitType.monthly ? (
          <h4>Valor total</h4>
        ) : (
          <h4>Valor total pago</h4>
        )}
        {proposalSplitType === ProposalSplitType.monthly ? (
          <span>{date ? `${getMonth(date)}/${getYear(date)}` : <></>}</span>
        ) : (
          <></>
        )}
      </div>
      <div>
        {dataContract ? (
          memoizedProgressBar
        ) : (
          <Skeleton
            style={{
              width: 106,
              height: 30,
              borderRadius: 4,
              marginBottom: 20,
            }}
          />
        )}
      </div>
      <div>
        {dataContract ? (
          <label style={{ marginBottom: 0 }}>
            <p
              style={{
                color: getAmoutColor(groups[0]?.status),
              }}
            >
              <Currency value={groups[0]?.splitted_amount} />
            </p>
            {dataContract.total_value != null ? (
              <span>
                &nbsp;/&nbsp;
                <Currency value={dataContract.total_value} />
              </span>
            ) : (
              <></>
            )}
          </label>
        ) : (
          <Skeleton
            style={{
              width: 106,
              height: 30,
              borderRadius: 4,
              marginBottom: 20,
            }}
          />
        )}
      </div>
    </div>
  );
};
